import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type GetCommunityMembersQueryParams = {
  cursor?: string;
  limit?: number;
};

type GetCommunityMembersResponse = Array<components['schemas']['UserList']>;

type GetCommunityMembersRouteParams = {
  id: string;
};

export const getCommunityMembers = async ({
  config: { params },
  routeParams: { id },
}: ConfigRouteParamsRequest<GetCommunityMembersQueryParams, GetCommunityMembersRouteParams>) =>
  apiClient.get<GetCommunityMembersResponse, ApiClientResponse<GetCommunityMembersResponse>>(
    routes.community.members(id),
    { params },
  );
